import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import TeeTimeRequestBookingsByHour from "../../../assets/components/reports/TeeTimeRequestBookingsByHour";

class TeeTimeRequestBookingsByHourReport extends Component {
    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    <div className='container'>
                        <div className='row'>
                            <div className='col'>
                                <h2>Tee-Time Requests by Hour</h2>
                            </div>
                        </div>

                        <div className='row mt-3'>
                            <div className='col'>
                                <TeeTimeRequestBookingsByHour />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default TeeTimeRequestBookingsByHourReport;
